<template>
  <div class="us-footer-wrap">
    <div class="copyright-wrap">
      <SysCopyright></SysCopyright>
    </div>
  </div>
</template>

<script>
import SysCopyright from '_c/sys-copyright'

export default {
  name: 'Footer',
  components: {
    SysCopyright
  },
}
</script>

<style lang="less" scoped>
.us-footer-wrap {
  height: @usFooterHeight;
  width: 100%;
  background-color: #414042;
  color: #ffffff;
}
</style>
